import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}


export const createRimborsoSpese = async (token: string, data: any) => {
    const response = await axios.post(`${API_URL}/cost-refunds/`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `${token}`,
      }
    })
    return response.data;
}

export const listaRichiesteRimborsoSpeseCompany = async (
  token: string, 
  page: number, 
  status: string, 
  pageSize: number = 10, 
  month: number,  
  year: number,
  permission: string | null,
) => {
  const response = await axios.get(`${API_URL}/cost-refunds/`, {
    headers: {
        'Authorization': token,
      },
      params: {
        page: page,
        page_size: pageSize,
        status: status,
        month: month,
        year: year
      },
      permission,
    } as CustomAxiosRequestConfig);
  return response.data;
}


export const processRichiestaRimborso = async (token: string, id: number, status: string) => {
    const formData = new FormData();
    formData.append('status', status);
  
    const response = await axios.patch(`${API_URL}/cost-refunds/${id}/`, 
      formData, 
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `${token}`,
        }
      }
    );
    return response.data;
}

export const patchRichiestaRimborso = async (token: string, id: number, updatedData: any) => {
  const formData = new FormData();
  
  formData.append('title', updatedData.title);
  formData.append('description', updatedData.description);
  formData.append('amount', updatedData.amount);
  formData.append('date', updatedData.date);

  if(updatedData.hasOwnProperty('file'))
    formData.append('file_binary', updatedData.file);

  const response = await axios.patch(`${API_URL}/cost-refunds/${id}/`, 
    formData, 
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `${token}`,
      }
    }
  );
  return response.data;
};

export const deleteRichiestaRimborso = async (token: string, id: string) => {
    const response = await axios.delete(`${API_URL}/cost-refunds/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
};
  